export default "__VITE_ASSET__Dtl855od__"